<template>
  <b-card no-body class="mt-3 border">
    <b-card-body>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h4 class="font-weight-600 mb-1">Resultado da importação</h4>
          <small class="text-gray">
            Importação
            <span v-if="!!result.importacao_id">
              #{{ result.importacao_id }}
            </span>
          </small>
        </div>

        <b-badge pill class="px-3 py-2" :class="statusColor">
          {{ statusLabel }}
        </b-badge>
      </div>

      <div class="row">
        <div
          v-for="item in summary"
          :key="item.label"
          class="col-12 col-md-4 mb-3"
        >
          <div class="border rounded-lg p-3 h-100">
            <small class="d-block text-gray mb-1" v-text="item.label" />
            <strong class="h3 font-weight-600 mb-0" v-text="item.value" />
          </div>
        </div>
      </div>

      <b-alert v-if="result.erro_mensagem" show variant="danger" class="mb-3">
        <font-awesome-icon icon="triangle-exclamation" class="mr-2" />
        {{ result.erro_mensagem }}
      </b-alert>

      <div v-if="reportItems.length">
        <h5 class="font-weight-600">Relatório</h5>
        <b-table
          small
          bordered
          responsive
          show-empty
          :items="reportItems"
          empty-text="Nenhuma ocorrência registrada."
          sticky-header
          class="max-height-scroll"
        />
      </div>

      <b-alert v-else show class="border bg-transparent text-dark mb-0">
        <h5 class="mb-1">Tudo certo!</h5>
        <p class="mb-0">Nenhuma ocorrência registrada no relatório.</p>
      </b-alert>
    </b-card-body>
    <b-card-footer class="d-inline-flex align-items-center">
      <b-button
        class="mr-0 border-0"
        variant="outline-exitos"
        @click="$emit('new-import')"
      >
        <font-awesome-icon icon="file-export" />
        Nova importação
      </b-button>
      <div class="mx-auto" />
      <b-button class="mr-0" variant="excel" @click="handleViewResult">
        Visualizar resultado
      </b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import { computed, defineComponent } from "vue";
import {
  STATUS_IMPORTER_COLOR,
  STATUS_IMPORTER_LABEL,
} from "@/modules/oportunidades/constants/statusImporterMunicipios";
import { safeArray } from "@/helpers/functions/ArrayHelpers";

export default defineComponent({
  props: {
    result: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["view-result", "new-import"],
  setup(props, { emit }) {
    const statusLabel = computed(
      () => STATUS_IMPORTER_LABEL[props.result.status] || props.result.status
    );
    const statusColor = computed(
      () => STATUS_IMPORTER_COLOR[props.result.status] || "bg-gray text-white"
    );

    const valueOrZero = (value) =>
      value === undefined || value === null ? 0 : value;

    const summary = computed(() => [
      {
        label: "Total de linhas",
        value: valueOrZero(props.result.total_linhas),
      },
      { label: "Importados", value: valueOrZero(props.result.importados) },
      { label: "Ignorados", value: valueOrZero(props.result.ignorados) },
    ]);

    const reportItems = computed(() =>
      safeArray(props.result.relatorio).map((item) =>
        typeof item === "object" ? item : { mensagem: item }
      )
    );

    function handleViewResult(e) {
      e?.currentTarget?.blur?.();

      emit("view-result");
    }

    return {
      reportItems,
      statusColor,
      statusLabel,
      summary,
      handleViewResult,
    };
  },
});
</script>
<style scoped lang="scss">
.max-height-scroll {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
